const radii = {
    '4xl': '2rem'
};

export default radii;
